
import {API_BASE_PATH} from '../const/api';

/**
 * Query JSON from the API
 * @param path - path to query
 * @param params - key/value object of query parameters to send
 * @param onSuccess
 * @param onFail
 * @return {XMLHttpRequest}
 */
export function ApiGetJSON(path, params, onSuccess, onFail){

	let paramString = '?';
	for( let i in params ){
		paramString += i+'='+params[i]+'&'
	}

	let xhr = new XMLHttpRequest();
	xhr.open("GET", `${API_BASE_PATH}${path}${paramString}`);

	xhr.onload = (e) => {
		if (e.target.status >= 200 && e.target.status < 300){
			try{
				onSuccess(JSON.parse( xhr.responseText ));
			} catch(e){
				onFail( `Error parsing response`);
			}
		} else {
			onFail(e.target.responseText || `Error ${e.target.status}`);
		}
	};
	xhr.onerror = (e) => {
		onFail("Error fetching download data");
	};
	xhr.send();

	return xhr;
}